import React from 'react';

import request from '@utils/axiosWrapper';
import { searchOrderByKeywordNew } from '@business/pages/OrderManage/Search/api';
import { RawOrderBaseInfo } from '@projects/Business/pages/OrderManage/wmOrder';
import { OrderBusinessType } from '@services/messageHub/instance/shared/types';
import { OrderDetailInfo } from '@projects/Business/pages/OrderManage/wmUnifiedOrder/types';

import { failToast } from '@utils/toast';

import {
    getFrameByName,
    FRAME_NAME,
    // sendMessageToSubFrame
} from '../../utils/subFrames';

import RedPacketModal from './RedPacketModal';
import ResendFoodModal, { CartDetailInfo } from './ResendFoodModal';

const { useState, useEffect, useCallback } = React;

enum SaveOrderOpType {
    RedPacket = 'redPacket',
    ResendFood = 'resendFood',
}

const SaveOrderOperations: React.FC = () => {
    const [saveOrderOp, setSaveOrderOp] = useState<{
        wmPoiId: string;
        wmOrderViewId: string;
        opType: SaveOrderOpType;
    } | null>(null);

    // 小额打款需要用到的预计收入和打款上限
    const [orderDetailInfo, setOrderDetailInfo] = useState<OrderDetailInfo | null>(null);
    // 补发餐品需要用的包裹信息
    const [carts, setCarts] = useState<CartDetailInfo[]>([]);

    // window.postMessage(JSON.stringify({type: 'SAVE_ORDER_OP', wmPoiId: "111", wmOrderViewId: '651573857907732', opType: 'redPacket'}))

    // 处理来自 IM frame 发来的挽单动作
    const imSaveOrderOpHandler = useCallback(
        (evt: MessageEvent) => {
            if (
                !!evt.source &&
                (evt.source === getFrameByName(FRAME_NAME.IM) || evt.source === window)
            ) {
                const data = evt.data;
                let parsedData: { [index: string]: any } = {};
                try {
                    parsedData = JSON.parse(data);
                } catch (e) {
                    // do nothing
                }

                if (parsedData.type === 'SAVE_ORDER_OP') {
                    setSaveOrderOp({
                        wmPoiId: parsedData.wmPoiId,
                        wmOrderViewId: parsedData.wmOrderViewId,
                        opType: parsedData.opType,
                    });
                }
            }
        },
        [setSaveOrderOp],
    );

    // 注册监听事件
    useEffect(() => {
        window.addEventListener('message', imSaveOrderOpHandler);
        return () => {
            window.removeEventListener('message', imSaveOrderOpHandler);
        };
    }, [imSaveOrderOpHandler]);

    // 拉取订单详情
    useEffect(() => {
        if (!!saveOrderOp && !!saveOrderOp.wmPoiId && !!saveOrderOp.wmOrderViewId) {
            if (saveOrderOp.opType === SaveOrderOpType.RedPacket) {
                searchOrderByKeywordNew({
                    pageNum: 1,
                    pageSize: 10,
                    sortType: 0,
                    code: -1,
                    searchItem: saveOrderOp.wmOrderViewId,
                }).then(res => {
                    const orderRawInfo = (res.data.wmOrderList as RawOrderBaseInfo[]).filter(
                        item => {
                            return (
                                item.businessType === OrderBusinessType.WM &&
                                JSON.parse(item.orderInfo).orderInfo.wmOrderViewId ===
                                    saveOrderOp.wmOrderViewId
                            );
                        },
                    )[0];

                    if (orderRawInfo) {
                        setOrderDetailInfo(JSON.parse(orderRawInfo.orderInfo));
                    } else {
                        failToast('查询订单详情失败');
                    }
                });
            }

            if (saveOrderOp.opType === SaveOrderOpType.ResendFood) {
                request
                    .get<CartDetailInfo[]>('/gw/api/order/refund/partRefund/foodInfo', {
                        params: {
                            wmPoiId: saveOrderOp.wmPoiId,
                            wmOrderViewId: saveOrderOp.wmOrderViewId,
                        },
                    })
                    .then(data => {
                        setCarts(data || []);
                    });
            }
        }
    }, [!!saveOrderOp, saveOrderOp?.wmPoiId, saveOrderOp?.wmOrderViewId, saveOrderOp?.opType]);

    // 关闭弹窗
    const closeModal = useCallback(() => {
        setSaveOrderOp(null);
        setOrderDetailInfo(null);
        setCarts([]);
    }, [setSaveOrderOp, setOrderDetailInfo, setCarts]);

    return (
        <div>
            {!!saveOrderOp &&
            saveOrderOp.opType === SaveOrderOpType.RedPacket &&
            orderDetailInfo ? (
                <RedPacketModal
                    visible
                    wmPoiId={saveOrderOp!.wmPoiId}
                    wmOrderViewId={saveOrderOp!.wmOrderViewId}
                    settleAmount={
                        (orderDetailInfo.refundInfo?.waitingRefundVo?.isShow &&
                            orderDetailInfo.refundInfo?.waitingRefundVo
                                ?.refundSecondaryPageExtraInfo.settleAmount) ||
                        ''
                    }
                    maximumCompensationAmount={
                        (orderDetailInfo.refundInfo?.waitingRefundVo?.isShow &&
                            orderDetailInfo.refundInfo?.waitingRefundVo
                                ?.refundSecondaryPageExtraInfo.maximumCompensationAmount) ||
                        30
                    }
                    onCancel={closeModal}
                />
            ) : null}
            {!!saveOrderOp &&
            saveOrderOp.opType === SaveOrderOpType.ResendFood &&
            carts.length > 0 ? (
                <ResendFoodModal
                    visible
                    onCancel={closeModal}
                    carts={carts}
                    wmPoiId={saveOrderOp!.wmPoiId}
                    wmOrderViewId={saveOrderOp!.wmOrderViewId}
                />
            ) : null}
        </div>
    );
};

export default SaveOrderOperations;
